import { render, staticRenderFns } from "./StoreBrandTile.vue?vue&type=template&id=da1f36ae&"
import script from "./StoreBrandTile.vue?vue&type=script&lang=js&"
export * from "./StoreBrandTile.vue?vue&type=script&lang=js&"
import style0 from "./StoreBrandTile.vue?vue&type=style&index=0&id=da1f36ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports